import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import api from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const { t } = useLang();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="relative min-h-screen">
      <div className="vl-noise" />
      <Header />
      <article className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-testid="blog-detail">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors mb-8"><ArrowLeft size={15} /> {t("back_to_blog")}</Link>
        {notFound && <p className="text-[var(--vl-stone)]">—</p>}
        {!post && !notFound && <Loader2 className="animate-spin text-[var(--vl-gold)]" />}
        {post && (
          <>
            <div className="text-[10px] tracking-widest uppercase text-[var(--vl-gold)] mb-3">{new Date(post.date).toLocaleDateString()}</div>
            <h1 className="font-serif-display text-4xl sm:text-5xl font-light text-[var(--vl-ivory)] leading-tight">{post.title}</h1>
            {post.cover && <div className="rounded-2xl overflow-hidden mt-8 h-72 sm:h-96"><img src={post.cover} alt={post.title} className="w-full h-full object-cover" /></div>}
            <div className="text-base text-[var(--vl-ivory)]/90 leading-relaxed mt-8 whitespace-pre-wrap font-light">{post.body}</div>
          </>
        )}
      </article>
      <Footer />
    </div>
  );
}
